import React from 'react';
import styled from 'styled-components';
import { ARIA_LABELS } from '../../constants/text';
import AlexLottie from '../alex/alexLottie';
import ALEX_STATES from '../alex/AlexStates';

const AlexWrapper = styled.div`
    position: absolute;
    width: 100%;
    display: flex;
    justify-content: flex-start;
    top: -1px;
`;

const StyledButton = styled.button`
    display: flex;
    flex: 0 1 auto;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    width: 221px;
    height: 112px;
    background-color: transparent;
    border: none;
    box-shadow: none;
    cursor: pointer;
    z-index: 3;

    &:active {
        opacity: 0.9;
    }

    &:focus-visible {
        border: 3px solid #100163;
        outline: 4px solid #fff;
        border-top: 0px;
    }

    padding: 0px;
`;

/**
 * Static (non-interactive) version of Alex avatar for gesture overlay.
 * Identical structure to Alex component but without Redux dependencies or side effects.
 * Shows animated AlexLottie in INACTIVE state.
 */
const StaticAlexAvatar = () => (
    <AlexWrapper>
        <StyledButton
            aria-label={ARIA_LABELS.ASK_ALYX_AGAIN}
            data-testid="inactive-Alex"
            disabled
            type="button"
        >
            <AlexLottie currentState={ALEX_STATES.INACTIVE} />
        </StyledButton>
    </AlexWrapper>
);

export default StaticAlexAvatar;
